export * from './baSlimScroll.directive';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/directives/baSlimScroll/index.ts